<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { inview } from "../actions";
  import SectionHead from "./SectionHead.svelte";
  import PhoneFrame from "./mockups/PhoneFrame.svelte";
  import ScreenPractice from "./mockups/ScreenPractice.svelte";
  import ScreenTutor from "./mockups/ScreenTutor.svelte";
  import ScreenGarden from "./mockups/ScreenGarden.svelte";
  import Sprout from "./Sprout.svelte";

  const f = $derived(i18n.t.features);
  const subjects = $derived(i18n.t.subjects.items);
  const screens = [ScreenPractice, ScreenTutor, ScreenGarden];
</script>

<section class="section section--rule" id="features">
  <div class="container">
    <SectionHead label={f.label} title={f.title} lead={f.lead} />

    <div class="rows">
      {#each f.items as item, i}
        {@const Screen = screens[i]}
        <article class="row" class:flip={i % 2 === 1}>
          <div class="text reveal" use:inview>
            <span class="n">{item.n}</span>
            <h3>{item.t}</h3>
            <p class="d">{item.d}</p>
            <ul class="bullets">
              {#each item.bullets as b}
                <li>
                  <svg viewBox="0 0 20 20" width="17" height="17" aria-hidden="true"><path d="M4 10.5l3.5 3.5L16 5" stroke="var(--green)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  <span>{b}</span>
                </li>
              {/each}
            </ul>
          </div>

          <div class="visual reveal" use:inview={{ delay: 120 }}>
            {#if Screen}
              <PhoneFrame label="Tane app screen — {item.t}">
                <Screen />
              </PhoneFrame>
            {:else}
              <div class="subjects-card card">
                <span class="sc-mark"><Sprout size={30} stage={4} /></span>
                <div class="sc-grid">
                  {#each subjects as s}
                    <span class="sc-chip">{s}</span>
                  {/each}
                </div>
              </div>
            {/if}
          </div>
        </article>
      {/each}
    </div>
  </div>
</section>

<style>
  .rows {
    margin-top: clamp(2.5rem, 1.5rem + 3vw, 4rem);
    display: flex;
    flex-direction: column;
    gap: clamp(3rem, 2rem + 4vw, 6rem);
  }
  .row {
    display: grid;
    grid-template-columns: 1fr 0.85fr;
    gap: clamp(2rem, 1rem + 4vw, 5rem);
    align-items: center;
  }
  .row.flip .text {
    order: 2;
  }

  .n {
    font-family: var(--font-mono);
    font-size: 0.85rem;
    letter-spacing: 0.15em;
    color: var(--terra);
  }
  h3 {
    font-size: clamp(1.5rem, 1.2rem + 1.4vw, 2.1rem);
    margin-top: 0.6rem;
  }
  .d {
    margin-top: 1rem;
    font-size: var(--fs-lead);
    color: var(--ink-soft);
    line-height: 1.85;
    max-width: 42ch;
  }
  .bullets {
    margin-top: 1.4rem;
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
  }
  .bullets li {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    color: var(--ink);
  }
  .bullets svg {
    flex: none;
    margin-top: 0.2em;
  }

  .visual {
    display: flex;
    justify-content: center;
  }

  .subjects-card {
    width: 100%;
    max-width: 380px;
    padding: 2rem 1.8rem;
    background:
      radial-gradient(120% 80% at 100% 0%, rgba(95, 179, 100, 0.1), transparent 60%),
      var(--paper-card);
  }
  .sc-mark {
    display: inline-grid;
    place-items: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: var(--sprout-soft);
    margin-bottom: 1.3rem;
  }
  .sc-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0.6rem;
  }
  .sc-chip {
    font-family: var(--font-mincho);
    font-size: 1rem;
    color: var(--ink);
    background: var(--paper);
    border: 1px solid var(--line);
    padding: 0.5em 0.95em;
    border-radius: 999px;
  }

  @media (max-width: 860px) {
    .row,
    .row.flip {
      grid-template-columns: 1fr;
    }
    .row .text,
    .row.flip .text {
      order: 1;
    }
    .visual {
      order: 2;
    }
  }
</style>
